import { TripOrderingTable } from '../../../global/interfaces';
import {
  GET_ORDERING_TRIPS_REQUEST,
  GET_ORDERING_TRIPS_SUCCESS,
  GET_ORDERING_TRIPS_ERROR,
  GET_ORDERING_UNLOADING_TRIPS_REQUEST,
} from './constants';

export const getTripsRequest = () => ({
  type: GET_ORDERING_TRIPS_REQUEST,
});

export const getUnloadingTripsRequest = () => ({
  type: GET_ORDERING_UNLOADING_TRIPS_REQUEST,
});

export const getTripsSuccess = (trips: TripOrderingTable[]) => ({
  type: GET_ORDERING_TRIPS_SUCCESS,
  payload: { trips },
});

export const getTripsError = (error: Error | null) => ({
  type: GET_ORDERING_TRIPS_ERROR,
  payload: { error },
});

export type Actions =
  | ReturnType<typeof getTripsRequest>
  | ReturnType<typeof getUnloadingTripsRequest>
  | ReturnType<typeof getTripsSuccess>
  | ReturnType<typeof getTripsError>;
